import { render, staticRenderFns } from "./TableAlunosTurma.vue?vue&type=template&id=3e48f590&scoped=true"
import script from "./TableAlunosTurma.vue?vue&type=script&lang=js"
export * from "./TableAlunosTurma.vue?vue&type=script&lang=js"
import style0 from "./TableAlunosTurma.vue?vue&type=style&index=0&id=3e48f590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48f590",
  null
  
)

export default component.exports